import React, { useRef } from "react";
import { Figure } from "../Figure";
import { MultipleLinesWithAverageData } from "../LineWithAverageData";
import { CategoryChart, prefixValue, suffixValue } from "../processors";
import { FigureSolidDashKpiProviders } from "../categoryChartQueryFns";
import { Paragraph, ParagraphWithoutWrapper } from "../Paragraph";
import { useCategoryContext } from "../Context";
import { CategoryTheme, PROVIDER_TITLE_CLASS } from "../misc";
import { getHighlightColors } from "../../themes";

// import ReactResizeDetector from "react-resize-detector";
import styles from "./CategoryChart.module.scss";

interface FigureWithSolidDashLineProvidersProps extends FigureSolidDashKpiProviders {
    categoryChart: CategoryChart;
}

export const FigureWithSolidDashLineProviders: React.FC<FigureWithSolidDashLineProvidersProps> = ({
    categoryChart,
    title,
    footer,
    unit,
    figures,
    graph,
    waterProviders
}) => {
    const { category } = useCategoryContext();
    const divRef = useRef<HTMLDivElement>();
    // const updateFigureHeights = useCallback(() => {
    //     if (divRef?.current) {
    //         const contentLabels = divRef?.current?.querySelectorAll(".std-figure .content label");

    //         console.log(contentLabels);
    //         const content = divRef?.current?.querySelectorAll(".std-figure .content");
    //         const maxHeight = _.max(Array.from(contentLabels).map(d => d.clientHeight ?? 0));
    //         Array.from(content).forEach(d => {
    //             (d as HTMLDivElement).style.height = `${maxHeight}px`;
    //         });
    //     }
    // }, []);

    // useEffect(() => {
    //     updateFigureHeights();
    // }, [updateFigureHeights]);

    // const onResize = useCallback(() => {
    //     updateFigureHeights();
    // }, [updateFigureHeights]);

    if (!category) return null;

    const theme = category.theme as CategoryTheme;
    const className = `col-md-${12 / (figures?.filter(d => d != null)?.length ?? 1)} col-12`;

    // getting colors for water providers
    const colors = getHighlightColors(theme, figures.length);

    return (
        <div className="row" ref={divRef}>
            {title != null && <Paragraph title={""} status={true} nid={0} text={title} className="col-12" />}
            {figures?.map((figure, index) => {
                const hasProviderTitleInFigureHeader =
                    (figure?.header?.processed ?? "").indexOf(PROVIDER_TITLE_CLASS) > -1;

                return (
                    <React.Fragment key={index}>
                        {figure && waterProviders?.[index] != null && (
                            <div className={`${className}`}>
                                {figure != null && (
                                    <Figure
                                        className="w-100"
                                        figureStyle={{
                                            color: colors[index]
                                        }}
                                        decimals={figure.decimals}
                                        header={
                                            !figure.header ? null : (
                                                <>
                                                    {!hasProviderTitleInFigureHeader && (
                                                        <div
                                                            className={`${styles.providerTitle} ${PROVIDER_TITLE_CLASS}`}
                                                        >
                                                            {waterProviders[index].name}
                                                        </div>
                                                    )}
                                                    <ParagraphWithoutWrapper
                                                        title={""}
                                                        status={true}
                                                        nid={0}
                                                        text={figure.header}
                                                    />
                                                </>
                                            )
                                        }
                                        footer={
                                            !figure.footer ? null : (
                                                <Paragraph title={""} status={true} nid={0} text={figure.footer} />
                                            )
                                        }
                                        value={figure.value}
                                        prefix={prefixValue(figure.value, unit)}
                                        suffix={suffixValue(figure.value, unit)}
                                        unitInSuffix={unit}
                                        unit={unit}
                                        categoryChart={categoryChart}
                                    />
                                )}
                            </div>
                        )}
                    </React.Fragment>
                );
            })}
            <div className={`col-12 ${styles.chart}`}>
                {graph != null && (
                    <MultipleLinesWithAverageData
                        measure={graph.measure}
                        theme={theme}
                        years={graph.years ?? []}
                        unit={unit}
                        providerMedianAnnotations={graph.providerMedianAnnotations ?? []}
                        providerMedianData={graph.providerMedianData ?? []}
                        providerMedianSeriesNames={graph.providerMedianSeriesNames ?? []}
                        // largeProviderAverageSeriesName={graph.largeProviderAverageSeriesName ?? ""}
                        // largeProviderAverageData={graph.largeProviderAverageData ?? []}
                        linesData={graph.linesData ?? []}
                        linesDataSeriesName={graph.linesDataSeriesName}
                        header={graph.header}
                        footer={graph.footer}
                    />
                )}
            </div>
            {footer != null && <Paragraph title={""} status={true} nid={0} text={footer} className="col-12" />}
            {/* <ReactResizeDetector handleWidth={true} onResize={onResize}></ReactResizeDetector> */}
        </div>
    );
};
